<template>
  <e-chart
    :header="`${documentTitle}`"
    :options="chartFormOptions"
    :series="chartFormSeries"
    class="item-large"
    chartId="FormTwo"
    :chartRedirectParams="chartRedirectParams"
    :chartLoading="chartLoading"
    :chartError="chartError"
    noDataText="Анализ невозможен, отсутствуют отчеты за указанный год."
    :alwaysDisableAnimation="true"
  >
    <template slot="exportData">
      <div class="chart-block__export-data">
        <div>
          Сравнение формы отчетности "2-ТП отходы" (Форма 2) от Росприроднадзора
          и формы отчетности из регионального кадастра отходов (Форма 2)
        </div>
        <div>Период: {{ fields.garbageProductionYear }}</div>
      </div>
    </template>
    <template slot="chartHeader">
      <div class="default-select part-1-from-4">
        <e-select
          @change="fetchData"
          tabView="tab1"
          :model="fields"
          name="formYear"
          :options="chartYearOptions"
        ></e-select>
      </div>
    </template>
  </e-chart>
</template>
<script>
import chartsMixin from '../mixins/charts-mixin'
import { analytic } from '@/api/api-endpoints'

export default {
  mixins: [chartsMixin],
  props: { limit: { type: Number, default: null } },
  computed: {
    getCurrentChartOptions() {
      return this.getChartOptions('formTwo')
    },
  },
  methods: {
    buildEndpoint() {
      return analytic.twoTpWasteFormTwo({
        query: {
          year: this.fields.formYear,
        },
      })
    },
    fetchData() {
      this.fetchChartData().then((r) => {
        this.chartFormSeries = this.transform(r)
        this.createAndSetCats(r, this.chartFormSeries)
      })
    },
    createAndSetCats(r) {
      let cats = []
      let indexForPosition = 0
      let positions = []
      Object.keys(r.data.regional).forEach((item) => {
        if (!['col_a', 'col_b', 'cnt'].includes(item)) {
          if (r.data._meta[item]?.label) {
            cats.push(r.data._meta[item]?.label)
          }
          positions.push(indexForPosition)
          indexForPosition++
        }
      })
      let options = Object.assign({}, this.chartFormOptions)
      options.xAxis.categories = cats
      options.xAxis.tickPositions = positions
      options.xAxis.max = this.limit
      this.chartFormOptions = Object.assign({}, options)
    },
    transform(data) {
      const newSeries = [
        {
          data: [],
        },
        {
          data: [],
        },
      ]
      let defaultSeries = this.getChartSeries('formTwo')
      for (const [key, value] of Object.entries(data.data['2tp_waste'])) {
        if (['col_a', 'col_b', 'cnt'].includes(key)) continue
        newSeries[0].data.push(Number(value))
      }
      for (const [key, value] of Object.entries(data.data['regional'])) {
        if (['col_a', 'col_b', 'cnt'].includes(key)) continue
        newSeries[1].data.push(Number(value))
      }
      newSeries.forEach((item, index) => {
        newSeries[index] = Object.assign(defaultSeries[index], newSeries[index])
      })
      return newSeries
    },
  },
  created() {
    this.chartFormOptions = this.getCurrentChartOptions
    this.fetchData()
  },
}
</script>
